import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import HttpClient from '../../utils/HttpClient';

export default class ChangeTypeModal extends Component {

  httpClient = new HttpClient();

  constructor(props) {
    super(props);
    this.metadata = this.props.metadata;
    this.strings = this.props.strings;
    this.state = {
      modal: false,
      selectedType: ''
    };
  }

  toggle = () => {
    const currentType = this.metadata?.Type?.value || this.metadata?.type?.value || '';
    this.setState({
      modal: !this.state.modal,
      selectedType: currentType
    });
  }

  onFormSubmit = async () => {
    const newType = this.state.selectedType;
    const docId = this.metadata['id'].value;
    
    if (!newType) {
      alert(this.strings['PleaseSelectType'] || 'Please select a type');
      return;
    }

    this.hide();

    try {
      await this.httpClient.changeType(docId, newType);
      if (this.metadata.Type) {
        this.metadata.Type.value = newType;
      } else if (this.metadata.type) {
        this.metadata.type.value = newType;
      }
      if (this.props.updateDocument) {
        this.props.updateDocument(this.metadata);
      }
      alert(this.strings['TypeChanged'] || 'Document type changed successfully');
    } catch (error) {
      console.error('Failed to change type:', error);
    }
  }

  hide = () => {
    this.setState({
      modal: false
    });
  }

  handleTypeChange = (event) => {
    this.setState({
      selectedType: event.target.value
    });
  }

  getTypeOptions = () => {
    const documentTypes = this.props.documentTypes;
    if (!documentTypes) return [];
    
    return Object.keys(documentTypes)
      .filter(typeKey => typeKey !== '*')
      .map((typeKey, index) => (
        <option key={index} value={typeKey}>{typeKey}</option>
      ));
  }

  render = () => {
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop={false} style={{ backgroundColor: '#f1f1f1' }}>
          <ModalHeader toggle={this.toggle}>
            {this.strings['ChangeDocumentType'] || 'Change Document Type'}
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="typeSelect">{this.strings['SelectNewType'] || 'Select new type'}:</Label>
                <Input 
                  type="select" 
                  name="typeSelect" 
                  id="typeSelect" 
                  value={this.state.selectedType}
                  onChange={this.handleTypeChange}
                >
                  <option value="">{this.strings['SelectType'] || 'Select type...'}</option>
                  {this.getTypeOptions()}
                </Input>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.onFormSubmit}>{this.strings['Change'] || 'Change'}</Button>
            <Button color="secondary" onClick={this.toggle}>{this.strings['Close']}</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
